import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, redirect, } from "react-router-dom";
import { JobBoard } from "./components/JobBoard";
import { setFilterSuids } from "./filterSuids";
import { normalizeJobCategorySuids } from "./jobCategorySuids";
import { normalizeJobTypeSuids } from "./jobTypeSuids";
import { SearchParamType } from "./types/SearchParamType";
var repeatableFilterNormalizers = new Map([
    [SearchParamType.JOB_CATEGORY_SUID, normalizeJobCategorySuids],
    [SearchParamType.JOB_TYPE_SUID, normalizeJobTypeSuids],
]);
function hasJobBoardSearchParams(searchParams) {
    var keys = Array.from(searchParams.keys());
    var jobBoardParams = Object.values(SearchParamType).filter(function (key) { return !repeatableFilterNormalizers.has(key); });
    return keys.some(function (key) { return jobBoardParams.includes(key); });
}
function haveSameValues(first, second) {
    return (first.length === second.length &&
        first.every(function (value, index) { return value === second[index]; }));
}
function createJobBoardLoader(filters) {
    var filterEntries = filters ? Array.from(filters) : [];
    return function (_a) {
        var request = _a.request;
        var url = new URL(request.url);
        var searchParams = url.searchParams;
        var originalSearch = searchParams.toString();
        var repeatableFilters = new Map(Array.from(repeatableFilterNormalizers, function (_a) {
            var paramType = _a[0], normalize = _a[1];
            return [
                paramType,
                {
                    normalize: normalize,
                    originalValues: searchParams.getAll(paramType),
                    values: normalize(searchParams.getAll(paramType)),
                },
            ];
        }));
        if (!hasJobBoardSearchParams(searchParams) && filterEntries.length > 0) {
            filterEntries.forEach(function (_a) {
                var _b;
                var key = _a[0], value = _a[1];
                var repeatableFilter = repeatableFilters.get(key);
                if (repeatableFilter) {
                    (_b = repeatableFilter.values).push.apply(_b, repeatableFilter.normalize(typeof value === "string" ? [value] : value));
                }
                else {
                    if (typeof value !== "string") {
                        throw new TypeError("Filter ".concat(key, " only supports a scalar value."));
                    }
                    searchParams.set(key, value);
                }
            });
        }
        repeatableFilters.forEach(function (_a, paramType) {
            var normalize = _a.normalize, originalValues = _a.originalValues, values = _a.values;
            var normalizedValues = normalize(values);
            if (!haveSameValues(originalValues, normalizedValues)) {
                setFilterSuids(searchParams, paramType, normalizedValues);
            }
        });
        if (searchParams.toString() !== originalSearch) {
            return redirect("?".concat(searchParams.toString()));
        }
        return null;
    };
}
export function router(filters) {
    var mainRoute = [
        {
            path: "/",
            element: _jsx(JobBoard, {}),
            loader: createJobBoardLoader(filters),
        },
    ];
    return createBrowserRouter(mainRoute, { basename: window.location.pathname });
}
